export default "__VITE_ASSET__0f532df8__"